import { Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { getRandomFact } from "../utils/helper";

interface Props {
  open: boolean;
  onClosingFactModal: () => void;
  onClickingLoginModal: () => void;
}

function FactModal(props: Props) {
  const { open, onClosingFactModal } = props;
  const userDetails = JSON.parse(localStorage?.getItem("user") as any);
  function greeting(): string {
    let date = new Date();
    let hours = date.getHours();
    if (hours < 12) return "Good Morning";
    else if (hours >= 12 && hours <= 17) return "Good Afternoon";
    else if (hours >= 17 && hours <= 24) return "Good Evening";
    return "";
  }
  return (
    <Dialog
      open={open}
      onClose={onClosingFactModal}
      fullWidth={true}
      maxWidth="xs"
      PaperProps={{
        style: {
          backgroundColor: "#1A202C",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 20px 10px 20px",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            flexGrow: 1,
          }}
        >
          <img src="RIVA_new.png" width={20} height={20} />
          <Typography color={"white"}>Fact of the Day</Typography>
        </div>
        <IconButton onClick={onClosingFactModal}>
          <Close style={{ color: "white" }} />
        </IconButton>
      </div>
      <Divider
        sx={{ borderBottomWidth: 1, backgroundColor: "white" }}
      ></Divider>
      <DialogTitle id="alert-dialog-title">
        {userDetails?.emp_name?.length > 0 ? (
          <Typography color={"white"}>{`Hello ${
            userDetails?.emp_name
          }! ${greeting()}`}</Typography>
        ) : (
          ""
        )}
      </DialogTitle>
      <DialogContent>
        <Typography
          id="alert-dialog-description"
          color={"white"}
          style={{ fontWeight: "bolder" }}
        >
          Do you know?
        </Typography>
        <br />
        <Typography
          id="alert-dialog-description"
          style={{ fontWeight: "bolder" }}
          color={"white"}
        >
          {getRandomFact()}
        </Typography>
      </DialogContent>
      {userDetails?.emp_name?.length > 0 ? (
        <DialogActions>
          <Button
            style={{
              color: "black",
              backgroundColor: "white",
              textTransform: "none",
            }}
            variant="contained"
            onClick={props?.onClickingLoginModal}
          >
            Not you? Login
          </Button>
          <Button
            style={{
              color: "black",
              backgroundColor: "white",
              textTransform: "none",
            }}
            variant="contained"
            onClick={onClosingFactModal}
          >
            {`I'm ${userDetails?.emp_name?.split(" ")[0]}`}
          </Button>
        </DialogActions>
      ) : (
        <DialogActions>
          <Button
            style={{
              color: "black",
              backgroundColor: "white",
              textTransform: "none",
            }}
            variant="contained"
            onClick={props?.onClickingLoginModal}
          >
            Login to continue
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default FactModal;
